import Hero from '../components/Hero'

export default function Equipo() {
  return (
    <article>
      {/* Hero Section */}
      <Hero 
        title="Nuestro Equipo"
        subtitle="Conoce a las personas detrás de La Gaviota"
        backgroundImage="/images/team/equipo_lagaviota.jpeg"
      />

      {/* Team Description */}
      <div className="w-screen flex justify-center py-16">
        <div className="w-full max-w-[800px] px-8">
          <div className="flex flex-col gap-6">
            <p className="body text-center">
              En La Gaviota IAP, contamos con un equipo multidisciplinario comprometido con la educación inclusiva y el desarrollo integral de cada niño y niña. Nuestro equipo está conformado por profesionales especializados en educación especial, terapia física, coordinación académica y administrativa.
            </p>
            <p className="body text-center">
              Trabajamos de manera colaborativa para crear un ambiente de aprendizaje seguro, cálido y estimulante donde todos los niños puedan desarrollar su máximo potencial.
            </p>
            <p className="body text-center text-gray-600">
              Ana Bertha, Ana Gloria, Julián, Karla, Katya, Lorena, María Del Carmen, María Elizabeth, María Margarita, María Teresa, Moonserath, Nancy, Patricia, Rosario y Tania.
            </p>
          </div>
        </div>
      </div>

    </article>
  )
} 